/**
 * Which reference this company's trips carry: Way Bill or Weight (kg).
 *
 * Read from the session rather than fetched, so the trip grid knows its
 * columns on the first paint. It changes only on the Company settings
 * tab, which re-reads the session after saving.
 */
import type { TripRefColumn } from '../api/types'
import { useAuth } from '../store/AuthContext'

export function useTripRef(): TripRefColumn {
  const { me } = useAuth()
  const co = me?.companies?.find((x) => x.id === me.company_id)
  return co?.trip_ref_column === 'WEIGHT' ? 'WEIGHT' : 'WAY_BILL'
}

/** Keep what a weight field can hold: digits, one point, two decimals.
 *  Commas are dropped because weighbridge tickets print 24,350.00. */
export function sanitizeWeight(v: string): string {
  const s = v.replace(/,/g, '').replace(/[^\d.]/g, '')
  const [whole, ...rest] = s.split('.')
  if (!rest.length) return whole
  return `${whole}.${rest.join('').slice(0, 2)}`
}

/** 24350.5 -> "24,350.50"; blank stays blank. */
export function formatKg(v: string | null | undefined): string {
  if (v === null || v === undefined || v === '') return ''
  const n = Number(v)
  if (!Number.isFinite(n)) return String(v)
  return n.toLocaleString('en-US', { minimumFractionDigits: 2,
                                     maximumFractionDigits: 2 })
}
